
var article = `
## Problemas al ejecutar mongodb-org en Kubuntu Jammy.

Puede pasar que luego de instalarlo, ejecute el servicio **mongod**:

> service mongod status

Pero este esté *fallando*.

* La solución es desinstalar la versión actual de **mongodb-org** e instalar **mongodb-org-4.4**

### Desinstalación de la versión actual

> sudo apt purge mongodb-org

### Eliminar el repositorio

**NOTA:** esto dependerá de el lugar donde esté creado el repo.

> sudo rm /etc/apt/sources.list.d/mongodb-org-5.0.list  **modificar la versión**

## Instalar mongodb-org 4.4 

Importar la clave GPG

> wget -qO - https://www.mongodb.org/static/pgp/server-4.4.asc | sudo apt-key add -

Agregar el repositorio de MongoDB

> echo "deb [ arch=amd64,arm64 ] https://repo.mongodb.org/apt/ubuntu focal/mongodb-org/4.4 multiverse" | sudo tee /etc/apt/sources.list.d/mongodb-org-4.4.list

Actualizar índice de paquetes

> sudo apt update

## Instalar MongoDB

> sudo apt install mongodb-org
      
Luego iniciar el servidor y habilitar para que se ejecute automáticamente cada vez que encienda:

> sudo systemctl start mongod
> sudo systemctl enable mongod
> systemctl status mongod
      
[Enlace a la fuente...](https://guias.donweb.com/como-instalar-y-configurar-mongodb-en-ubuntu-20-04/)
`;

export default article;